import { css } from '@emotion/css';

import { colors } from '@ajaibid/components';

const { NEUTRAL_0, NEUTRAL_1 } = colors;

export const styLayoutContainer = css`
  height: 100%;
`;

export const styPanelWrapper = css`
  display: flex;
  flex-direction: row;
  height: calc(100% - 48px);
  width: 100%;
  background: ${NEUTRAL_1};
  position: fixed;
  bottom: 0;
`;

export const styPanelContainer = css`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const styPanelContent = css`
  position: relative;
  display: flex;
  overflow: auto;
  height: 100%;
`;

export const styPanelRoot = css`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const styMainPanel = (props) => {
  const {
    isRightPanelVisible,
    isTradePanelVisible,
    isBottomPanelNormal,
    isBottomPanelCollapsed,
    isBottomPanelExpand,
    withBottomPanel,
  } = props;

  let rightInset = 0;
  switch (true) {
    case isRightPanelVisible && isTradePanelVisible:
      rightInset = '648px'; // RightPanel size 320px + TradePanel size 320px, margin 8px
      break;
    case isRightPanelVisible && !isTradePanelVisible:
      rightInset = '324px'; // RightPanel size 320px, margin 4px
      break;
    case !isRightPanelVisible && isTradePanelVisible:
      rightInset = '324px'; // TradePanel size 320px, margin 4px
      break;
    case !isRightPanelVisible && !isTradePanelVisible:
    default:
      break;
  }

  let bottomInset = 0;
  switch (true) {
    case !withBottomPanel:
      bottomInset = '0px'; // No offset
      break;
    case isBottomPanelExpand:
      bottomInset = '100%'; // No offset
      break;
    case isBottomPanelNormal:
      bottomInset = '362px'; // BottomPanel default size 362px (show 3 rows of data)
      break;
    case isBottomPanelCollapsed:
      bottomInset = '40px'; // BottomPanel Toolbar size 40px
      break;
    default:
      break;
  }

  const totalInset = `0% ${rightInset} ${bottomInset} 0%`;

  return css`
    position: absolute;
    ${isBottomPanelExpand && 'opacity: 0'};
    inset: ${totalInset};
    border-radius: 4px;
    background: ${NEUTRAL_0};
    margin: 4px 2px 0px 0px;
    z-index: 0;
  `;
};

export const styTradePanel = (props) => css`
  position: absolute;
  width: 320px;
  inset: ${props.isRightPanelVisible
    ? '0% calc(100% - 324px) 0% calc(100% - 648px)' // TradePanel size 320px, margin 4px
    : '0% calc(100% - 324px) 0% calc(100% - 324px)'}; // TradePanel size 320px, RightPanel size 320px, margin 4px
  background: ${NEUTRAL_0};
  border-radius: 4px;
  margin: 4px 2px 0px 2px;
`;
